import { useCallback, memo } from "react";
import PropTypes from "prop-types";
import "./LogoBrand.scss";
import { brandPropTypes } from "app/utils/propTypes";
import { sendTagOnLogoRedirect } from "app/utils/analytics";
import classNames from "classnames";

const LogoBrand = ({
	shop = "",
	brand = "",
	isWhite = false,
	theme = {},
	showSpanLogo = false,
}) => {
	const onClick = useCallback(() => {
		sendTagOnLogoRedirect();
	}, []);

	const logoBrandClassNames = classNames({
		[`logo-brand logo-brand--${brand}-${shop}`]: true,
		[`logo-brand logo-brand--${brand}-${shop}-white`]: isWhite,
	});
	return theme?.logo && !showSpanLogo ? (
		<img
			data-testid="logo-brand"
			onClick={onClick}
			src={theme?.logo}
			className={"logo-brand__logo"}
		/>
	) : (
		<span data-testid="logo-brand" onClick={onClick} className={logoBrandClassNames} />
	);
};

LogoBrand.propTypes = {
	shop: PropTypes.string,
	isWhite: PropTypes.bool,
	brand: brandPropTypes,
	theme: PropTypes.object,
	showSpanLogo: PropTypes.bool,
};

export default memo(LogoBrand);
